/**
 * Плитка съёмочной площадки: обложка (по `cover_id`, иначе первое фото), «N фото · M платьев»;
 * клик открывает площадку. Выделения на уровне площадок нет — выделяют фото внутри.
 */
import { RetryImg } from "@/components/trends/PinGrid";
import { plural, type ReferenceItem } from "@/lib/library";
import { num, thumbUrl } from "@/lib/media";
import type { Site } from "@/lib/sites";

export function SiteTile({
  site,
  cover,
  count,
  onOpen,
}: {
  site: Site;
  /** Фото площадки, найденные среди референсов библиотеки (не `site.size` сервера). */
  count: number;
  cover: ReferenceItem | undefined;
  onOpen: () => void;
}) {
  const ratio = cover?.asset_width && cover.asset_height ? `${cover.asset_width} / ${cover.asset_height}` : "3 / 4";
  const caption = `${num(count)} фото · ${num(site.dresses)} ${plural(site.dresses, "платье", "платья", "платьев")}`;
  return (
    <figure className="grid min-w-0 content-start gap-1" data-annot="площадка">
      <button
        type="button"
        onClick={onOpen}
        className="relative block max-h-[360px] w-full overflow-hidden rounded-[var(--radius-card)] border border-border bg-bg-subtle text-left focus-visible:outline-2 focus-visible:outline-accent"
        style={{ aspectRatio: ratio }}
        title="Открыть площадку"
        aria-label={`Площадка ${site.number}: ${caption}`}
      >
        {cover ? (
          <RetryImg
            src={thumbUrl(cover.asset_path)}
            alt={`Площадка ${site.number}`}
            className="absolute inset-0 h-full w-full object-cover"
          />
        ) : null}
      </button>
      <figcaption className="grid min-w-0 gap-0.5 px-0.5">
        <span className="truncate font-medium">Площадка {site.number}</span>
        <span className="truncate text-[11.5px] text-fg-faint tnum">{caption}</span>
      </figcaption>
    </figure>
  );
}
